import { Head, useForm } from '@inertiajs/react'
import { SubmitEvent } from 'react'
import DriverCarForm, { DriverCarFormData } from './_form'
import { DriverCarsEditProps } from '@/types/driver_cars'

export default function EditDriverCar({ driver_car, photos, participant, color_families, aspirations, errors }: DriverCarsEditProps) {
  const { id, ...fields } = driver_car
  const { data, setData, patch, processing } = useForm<DriverCarFormData>({
    participant,
    remove_photo_ids: [],
    driver_car: { ...fields, new_photos: [] }
  })

  const handleSubmit = (e: SubmitEvent) => {
    e.preventDefault()
    patch(`/driver_cars/${id}`, { forceFormData: true })
  }

  return (
    <>
      <Head title="Edit Car" />
      <div style={{ padding: "20px", maxWidth: "800px", margin: "0 auto" }}>
        <DriverCarForm
          data={data}
          setData={setData}
          onSubmit={handleSubmit}
          processing={processing}
          errors={errors}
          title="Edit Car"
          submitLabel="Update Car"
          colorFamilies={color_families}
          aspirations={aspirations}
          photos={photos}
        />
      </div>
    </>
  )
}
